import Image from 'next/image';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import devices from '@/utilities/devices';

const ArticlePreview = styled.a`
  position: relative;
  width: 50%;
  height: 100%;
  z-index: 998;
  color: ${props => props.theme.color.white};
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  text-decoration: none;
  @media screen and (${devices.mobile}) {
    width: 100%;
  }
`;

const ImagePreview = styled(Image)`
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: -999;
  transition: .35s;
  ${ArticlePreview}:hover & {
    transform: scale(1.02);
  }
`;

const Filter = styled.div`
  overflow: hidden;
  display: block;
  background: rgb(0,0,0);
  background: linear-gradient(0deg, rgba(0,0,0,0.5844538498993348) 20%, rgba(255,255,255,0) 80%);
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 55%;
  z-index: -999;
  transition: .4s;
  @media screen and (${devices.mobile}) {
    height: 100%;
    background: linear-gradient(0deg, rgba(0,0,0,0.4844538498993348) 40%, rgba(255,255,255,0) 100%);
  }
  @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
    height: 100%;
  }
`;

const ArticleInformation = styled.div`
  display: block;
  padding: 2.5em 1.5em 2.5em;
  transition: .3s;
  ${ArticlePreview}:hover & {
    padding-bottom: 2.8em;
  }
  .title {
    padding: .5em .6em;
    font-weight: bold;
    -webkitBoxOrient: vertical;
    -webkitLineClamp: 2;
		display: -webkit-box;
    overflow: ellipsis;
  }
  .date {
    padding: .2em .6em;
    opacity: 0;
    transform: translateY(-10px);
    word-spacing: 4px;
    transition: .3s;
    ${ArticlePreview}:hover & {
      opacity: 1;
      transform: translateY(0px);
    }
    @media screen and (${devices.mobile}) {
      opacity: 1;
      transform: translateY(0px);
    }
    @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
      opacity: 1;
      transform: translateY(0px);
    }
  }

  img {
    display: block;
    width: 27%;
    padding: 1.5em .5em;
    @media screen and (${devices.mobile}) {
      padding: 1.5em .5em .5em;
    }
  }
`;

const PreviewPress = ({ title, date, logo, alt, href, bgImage }) => {
	return (
		<>
			<ArticlePreview href={href}>
				<ArticleInformation>
					<div> <img src={logo} alt={alt} loading="lazy" /> </div>
					<div className="title">{title}</div>
					<div className="date">{date}</div>
				</ArticleInformation>
				<ImagePreview
					src={bgImage}
					alt="preview press image"
					fill
					priority={false}
					quality={80}
					style={{ objectFit: 'cover' }}
					unoptimized={true}
				/>
				<Filter />
			</ArticlePreview>
		</>
	);
};

PreviewPress.propTypes = {
	title: PropTypes.string,
	date: PropTypes.string,
	logo: PropTypes.string,
	alt: PropTypes.string,
	href: PropTypes.string,
	bgImage: PropTypes.string,
};

export default PreviewPress;
